import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  imports: [RouterLink, RouterLinkActive],
  selector: 'app-nav-bar',
  styles: ``,
  templateUrl: './nav-bar.component.html',
})
export class NavBarComponent {
  readonly options = [
    {
      icon: 'draw',
      name: 'Create project',
      route: 'create',
      shortName: 'Create',
    },
    {
      icon: 'list',
      name: 'Project list',
      route: 'list',
      shortName: 'Projects',
    },
    {
      icon: 'public',
      name: 'Result map',
      route: 'results',
      shortName: 'Results',
    },
  ];
}
